import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import CoverAction from './CoverAction';

function CoverLink({ to, ...props }) {
  const storeRoute = useSelector(state => state.storeRoute);
  const allowAccess = useSelector(state => state.allowAccess); // Double Tap OR Normal Click OR Touch
  const isLinkage = useSelector(state => state.isLinkage);
  const setHistory = () => {
    if (isLinkage && allowAccess) {
      storeRoute.goTo(to);
    }
  }
  return (
    <CoverAction {...props} onClick={setHistory} style={{ zIndex: 60 }} size={`100%`} />
  )
}

CoverLink.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default CoverLink;
